var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row flex-wrap"},_vm._l((_vm.images),function(img,i){return _c('v-img',{key:'img-' + i,staticClass:"ma-2 selectable",attrs:{"alt":img.alt,"src":img.src,"max-height":"100","max-width":"100"},on:{"click":function($event){return _vm.selectImage(img)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }